"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var AxiosErrorParser_1 = require("Errors/AxiosErrorParser");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_2 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var PageCollectionSection_1 = require("./PageCollection/PageCollectionSection");
var CurrencySection_1 = require("./CurrencySection/CurrencySection");
var Cleanup_1 = require("./CleanupSection/Cleanup");
var Types_2 = require("Reports/Types");
var EngagementSection_1 = require("./EngagementSection");
var allTimezones = require("./timezones.json");
var AnalyticsAndReportingSettingsController = (function () {
    function AnalyticsAndReportingSettingsController(createUi, rootDataStore, telemetry, mountReactComponent) {
        this.ui = createUi(require("./AnalyticsAndReporting.html"), {
            analyticsAndReportingSettings: mountReactComponent(react_1.default.createElement(AnalyticsAndReportingSettings, { accountStore: rootDataStore.getAccountDataStore(), telemetry: telemetry })),
        });
    }
    return AnalyticsAndReportingSettingsController;
}());
function getUtc(allTimezones) {
    return allTimezones.find(function (tz) {
        if (tz === "Etc/UTC") {
            return tz;
        }
    });
}
var c = (0, BemBuilder_1.default)("analytics-and-reports-settings");
var AnalyticsAndReportingSettings = (function (_super) {
    __extends(AnalyticsAndReportingSettings, _super);
    function AnalyticsAndReportingSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.errorMessage = "";
        _this.save = function () { return __awaiter(_this, void 0, Promise, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, this.props.accountStore.setTimezone(this.timezone)];
                    case 1:
                        _a.sent();
                        this.props.telemetry.trackOnly(Types_2.ReportTelemetryEventName.AnalyticsAndReportingSettingsChanged, {
                            update_type: "timezone",
                            update_value: this.timezone,
                        }, { blockIntercom: true });
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.setErrorMessage((0, AxiosErrorParser_1.isAxiosError)(err_1) ? (0, AxiosErrorParser_1.getErrorMessage)(err_1) : "Something went wrong. Please try again in a moment");
                        throw err_1;
                    case 3: return [2];
                }
            });
        }); };
        return _this;
    }
    AnalyticsAndReportingSettings.prototype.setErrorMessage = function (error) {
        this.errorMessage = error;
    };
    Object.defineProperty(AnalyticsAndReportingSettings.prototype, "getCurrentlySelectedTimezoneLabel", {
        get: function () {
            var _a, _b;
            var selectedTimezone = (_b = (_a = this.timezone) !== null && _a !== void 0 ? _a : this.props.accountStore.getAccountTimezone()) !== null && _b !== void 0 ? _b : getUtc(allTimezones);
            if (selectedTimezone) {
                return this.getLabel(selectedTimezone);
            }
            else {
                return "";
            }
        },
        enumerable: false,
        configurable: true
    });
    AnalyticsAndReportingSettings.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement(icons_1.Analytics, { size: icons_1.IconSize.Large, className: c("icon") }),
            react_1.default.createElement("div", { className: c("heading") },
                react_1.default.createElement(kaleidoscope_1.Label, { className: c("main_title"), size: "l" }, "Analytics & Reporting"),
                react_1.default.createElement(kaleidoscope_2.Text, { className: c("explainer"), element: "div", align: "center", strong: true, size: "xs" }, "Manage settings for Analytics and Reports")),
            react_1.default.createElement("div", { className: c("body") },
                react_1.default.createElement("div", { className: c("timezone-section") }, react_1.default.createElement(kaleidoscope_1.Combobox, { label: "Account time zone", size: kaleidoscope_1.TextInputSize.Medium, placeholder: "Select timezone", startingSearchTerm: this.getCurrentlySelectedTimezoneLabel, entries: allTimezones.map(function (tz) {
                        return { label: tz, value: tz, data: tz };
                    }), onSelect: function (entry) {
                        (0, mobx_1.runInAction)(function () {
                            _this.timezone = entry.data;
                        });
                    }, renderInput: function (_a) {
                        var _b;
                        var onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, rest = __rest(_a, ["onChange", "onBlur", "onFocus"]);
                        return (react_1.default.createElement(kaleidoscope_1.TextInput, __assign({}, rest, { label: "Account time zone", size: kaleidoscope_1.TextInputSize.Large, placeholder: "Find a timezone", endElement: react_1.default.createElement(icons_2.ChevronDown, null), value: (_b = _this.searchTerm) !== null && _b !== void 0 ? _b : _this.getCurrentlySelectedTimezoneLabel, onChange: function (value) {
                                onChange(value);
                                (0, mobx_1.runInAction)(function () {
                                    _this.searchTerm = value;
                                });
                            }, onFocus: function (event) {
                                onChange("");
                                onFocus(event);
                            }, onBlur: function (event) {
                                onBlur(event);
                                (0, mobx_1.runInAction)(function () {
                                    _this.searchTerm = undefined;
                                });
                            }, labelHidden: false })));
                    } })),
                react_1.default.createElement(kaleidoscope_1.Button, { className: c("update-button"), onClick: this.save, size: kaleidoscope_1.ButtonSize.Large, disabled: !this.timezone || this.timezone === this.props.accountStore.getAccountTimezone() }, "Update timezone"),
                react_1.default.createElement("div", { className: c("section") },
                    react_1.default.createElement(CurrencySection_1.CurrencySection, { className: c() })),
                react_1.default.createElement(EngagementSection_1.EngagementSection, null),
                react_1.default.createElement(PageCollectionSection_1.PageCollectionSection, null),
                react_1.default.createElement("div", { className: c("section") },
                    react_1.default.createElement(Cleanup_1.Cleanup, null)))));
    };
    AnalyticsAndReportingSettings.prototype.getLabel = function (timezone) {
        return "".concat(timezone);
    };
    var _a;
    __decorate([
        mobx_1.observable.deep,
        __metadata("design:type", typeof (_a = typeof Types_1.Timezone !== "undefined" && Types_1.Timezone) === "function" ? _a : Object)
    ], AnalyticsAndReportingSettings.prototype, "timezone", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AnalyticsAndReportingSettings.prototype, "errorMessage", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AnalyticsAndReportingSettings.prototype, "searchTerm", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], AnalyticsAndReportingSettings.prototype, "setErrorMessage", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], AnalyticsAndReportingSettings.prototype, "getCurrentlySelectedTimezoneLabel", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AnalyticsAndReportingSettings.prototype, "save", void 0);
    AnalyticsAndReportingSettings = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AnalyticsAndReportingSettings);
    return AnalyticsAndReportingSettings;
}(react_1.default.Component));
exports.default = AnalyticsAndReportingSettingsController;
